import React, { useEffect, useState, useContext } from "react";
import { InteractionType } from "@azure/msal-browser";
import { MsalAuthenticationTemplate, useMsal } from "@azure/msal-react";

import { loginRequest } from "./authConfig";
import { PageLayout } from "./components/PageLayout";
import { DirectReports } from "./components/DirectReports";
import { RecruitmentRequests } from './components/RecruitmentRequests';
import { getMyDirectReports } from "./graph";
import  { Context } from "./Context.js";
import {Buffer} from "buffer";

import "./styles/App.css";

/**
 * Renders information about the signed-in user or a button to retrieve data about the user
 */
const ProfileContent = () => {
    const { instance, accounts } = useMsal();
    const [directReportsData, setDirectReportsData] = useState(null);
    const [ department, setDepartment ] = useState(null);
    const [loadMoreLink, setLoadMoreLink] = useState(null);
    const [, setIsLoading] = useContext(Context);

    useEffect(() => {
        setIsLoading(true);
        // Silently acquires an access token which is then attached to a request for MS Graph data
        instance.acquireTokenSilent({
            ...loginRequest,
            account: accounts[0]
        }).then((response) => {
            const token = Buffer.from(response.accessToken.split('.')[1], 'base64');
            const decoded = JSON.parse(token.toString('ascii'));
            setDepartment(decoded.department);
            getMyDirectReports(response.accessToken).then(directReports => {
                setDirectReportsData(directReports.users);
                setLoadMoreLink(directReports.loadMoreLink);
                setIsLoading(false);
            });
        });
    }, []);

    const onLoadNextPage = (skipToken) => {
        setIsLoading(true);
        // Silently acquires an access token which is then attached to a request for MS Graph data
        instance.acquireTokenSilent({
            ...loginRequest,
            account: accounts[0]
        }).then((response) => {
            getMyDirectReports(response.accessToken, skipToken).then(directReports => {
                setDirectReportsData([...directReportsData, ...directReports.users]);
                setLoadMoreLink(directReports.loadMoreLink);
                setIsLoading(false);
            });
        });
    }

    return (
        <>
            <RecruitmentRequests department={department} />
            <DirectReports directReports={directReportsData} department={department} loadMoreLink={loadMoreLink} onLoadNextPage={onLoadNextPage}/>
        </>
    );
};

/**
 * If a user is authenticated the ProfileContent component above is rendered. Otherwise a message indicating a user is not authenticated is rendered.
 */
const MainContent = () => {    
    return (
        <div className="App">
            <MsalAuthenticationTemplate interactionType={InteractionType.Redirect}>
                <ProfileContent />
            </MsalAuthenticationTemplate>
        </div>
    );
};

export default function App() {
    const [loading, setIsLoading] = useState(false);

    const handleTouchMove = (e) => {
        e.preventDefault();
    };

    useEffect(() => {
        if (loading) {
            var body = document.body;
            body.className += " lock-screen";
            body.addEventListener('touchmove', handleTouchMove, { passive: false });
        } else {
            var body = document.body;
            body.classList.remove("lock-screen");
            body.removeEventListener('touchmove', handleTouchMove);
        }
    }, [loading]);

    return (
        <>
            {loading && ( 
                <div className="loadingModal">
                    <i className="loader"></i>
                </div>
            )}
            <Context.Provider value={[loading, setIsLoading]}>    
                <PageLayout>
                    <MainContent />
                </PageLayout>
            </Context.Provider>
        </>
    );
}
